/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useSiteMetadata } from '../hooks/site-metadata'
import { usePageMetadata } from '../hooks/page-metadata'
// components
import Header from './Header'
import Footer from './Footer'

import './layout.scss'

const Layout = ({ children }) => {
    const siteMetadata = useSiteMetadata();
    const pageMetadata = usePageMetadata();

    return (
        <>
            {/* <h1 className='sr-only'>Happy Sunny &amp; Co.</h1> */}
            <Header 
                siteTitle={siteMetadata.title} 
                pageMetadata={pageMetadata} 
            />
            <main 
                type="main" 
                className="main"
            >{children}</main>
            <Footer 
                siteTitle={siteMetadata.title} 
                pageMetadata={pageMetadata} 
            />
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
